import React from 'react'
import PropTypes from 'prop-types'
import { SCHEDULED } from 'domains/seller-inbound/constants/seller-inbound-pickup-constants'
import StatusBadge from 'components/atoms/status-badge'


const propTypes = {
  scheduled: PropTypes.bool
}

/**
 * To give nice look on Seller Inbound Pickup `scheduled`.
 * It maps `scheduled` to certain style and pass to `StatusBadge`.
 * @param {string} scheduled seller type. available values
 * - `true`
 * - `false`
 */
const SellerInboundPickupScheduledBadge = ({ scheduled }) => {

  const colorMap = {
    [SCHEDULED.YES] : 'success',
    [SCHEDULED.NO]  : 'warning'
  }

  const labelMap = {
    [SCHEDULED.YES] : 'Scheduled',
    [SCHEDULED.NO]  : 'Unscheduled'
  }

  const color = colorMap[scheduled] || 'default'
  const label = labelMap[scheduled] || ''

  return <StatusBadge color={ color } label={ label } />
}

SellerInboundPickupScheduledBadge.propTypes = propTypes

export default SellerInboundPickupScheduledBadge